import { Controller } from '@hotwired/stimulus'
import { useIntersection } from 'stimulus-use'

import { track, trackSegment, sendFbClick } from '../utils/track'

export default class TrackingController extends Controller {
  static values = {
    event: String,
    properties: Object
  }

  connect() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useIntersection(this)
  }

  appear(entry) {
    if (this.eventValue) {
      const formSrc = entry.target.getAttribute('data-src')
      const formSrcId = entry.target.getAttribute('data-src-id')
      trackSegment(this.eventValue, {
        ...this.propertiesValue,
        form_id: formSrc || this.propertiesValue.form_id,
        form_name: formSrc || this.propertiesValue.form_name,
        form_started_id: formSrcId || this.propertiesValue.form_started_id
      })
    }
  }

  track(e) {
    const { event, label, value } = e.params

    track(event, label, value)
  }

  trackSegment(e) {
    const { event, properties } = e.params

    trackSegment(event, properties)
  }

  sendFbClick() {
    sendFbClick()
  }
}
